import 'lazysizes';
import CustomLayout from './wrapPageElement';

require('prismjs/themes/prism-tomorrow.css');

export const wrapPageElement = CustomLayout;
